import React from 'react';
import { Search, X } from 'lucide-react';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onClear?: () => void;
  className?: string;
  size?: 'sm' | 'md';
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      onChange,
      placeholder,
      onClear,
      className = '',
      size = 'md',
    },
    ref,
  ) => {
    const showClear = value.length > 0;
    const paddingRight = showClear ? 'pr-9' : 'pr-3';

    const handleClear = () => {
      if (onClear) {
        onClear();
      } else {
        onChange('');
      }
    };

    return (
      <div className={`relative ${className}`}>
        <Search
          size={14}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-content-faint pointer-events-none"
        />
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`w-full pl-9 ${paddingRight} py-2.5 rounded-xl bg-surface-primary border border-subtle text-content text-xs placeholder-content-muted outline-none focus:border-brand/40 transition-all`}
        />
        {showClear && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-content-faint hover:text-content-secondary transition-colors p-0.5 rounded"
            aria-label="Clear search"
          >
            <X size={14} />
          </button>
        )}
      </div>
    );
  },
);

SearchInput.displayName = 'SearchInput';

export default SearchInput;
